const PasswordRegex = /^(?=.*[A-Za-z]{1})(?=.*\d{1})(?=.*[\W_]{1}).{10,}$/;

export default PasswordRegex;
